module.exports = __webpack_public_path__ + "static/media/TITAN-MATIC.dd461699.png";